module.exports = __webpack_public_path__ + "static/media/3.9.280e1aa8.png";